<div class="body-login">
  <div class="container">
    <div class="login-container">
      <dx-form
        [formData]="senderEmail"
        [readOnly]="false"
        [showColonAfterLabel]="true"
        [showValidationSummary]="true"
        validationGroup="customerData"
      >
        <dxi-item itemType="group">
          <dxi-item>
            <div *dxTemplate class="mt-2 text-center">
              <img
                width="100"
                src="../../../../assets/icons/ekisa-logo-negro.png"
                alt="icon"
              />
              <h2>Restablecer inicio de sesión.</h2>
            </div>
          </dxi-item>

          <dxi-item
            dataField="email"
            [editorOptions]="{ stylingMode: 'underlined' }"
          >
            <dxo-label text="Correo electrónico"></dxo-label>
            <dxi-validation-rule
              type="required"
              message="El correo electrónico es requerido"
            >
            </dxi-validation-rule>
            <dxi-validation-rule
              type="email"
              message="El correo electrónico no es válido."
            >
            </dxi-validation-rule>
          </dxi-item>
        </dxi-item>

        <dxi-item itemType="group">
          <dxi-item
            itemType="button"
            horizontalAlignment="center"
            [buttonOptions]="{
              type: 'default',
              text: 'Enviar',
              width: '60%',
              height: 50,
              onClick: onSubmit
            }"
          >
          </dxi-item>
        </dxi-item>
      </dx-form>
    </div>
  </div>
</div>
